import { FunctionComponent, useCallback, useMemo, useState } from "react";
import api from "../../utils/api";
import { FormLabel, Grid, MenuItem, Select } from "@mui/material";
import { T_Evento } from "./celula";


interface SelectAtividadeSedeProps {
  idgrupo: number | undefined
  value?: string | number
  onChange: (e: any) => void
  getDescription?: (e: any) => void
}

const SelectAtividadeGrupo: FunctionComponent<SelectAtividadeSedeProps> = ({ idgrupo, value: _val, onChange, getDescription }) => {

  const [events, setEvents] = useState<T_Evento[]>();


  const getEvents = async () => {
    try {
      const req = await api.get(`atividade/geral/grupo/${idgrupo}`);
      const res = req?.data;

      setEvents(res);
    } catch (error) {

    }
  }

  useMemo(() => {
    getEvents()
  }, [idgrupo])

  const Selecter = useCallback(() => {
    return (
      <Select
        value={_val}
        onChange={onChange}
      >
        {
          events?.map(
            ministerio =>
              <MenuItem value={ministerio?.id} onClick={() => getDescription?.(ministerio?.descricao)}>
                {ministerio?.descricao}
              </MenuItem>
          )
        }
      </Select>
    )

  }, [idgrupo, events, _val])

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Atividade</FormLabel>
        {
          events && (
            <Selecter />
          )
        }
      </Grid>
    </>
  )
}

export default SelectAtividadeGrupo;
